const API_KEY = "lHKuOdlGuytoSx4ZxcPaWiBliGWfNZFo";

export const SEARCH_LIMIT = 25;

const FETCH_TIMEOUT = 20 * 1000;

export async function giphy_search(text: string, offset: number = 0) {
    // https://developers.giphy.com/docs/api/endpoint#search
    const SEARCH_URL = "https://api.giphy.com/v1/gifs/search";
    const params = new URLSearchParams({
        api_key: API_KEY,
        q: text,
        limit: SEARCH_LIMIT.toString(),
        offset: offset.toString()
    });

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), FETCH_TIMEOUT);
    try {
        const resp = await fetch(`${SEARCH_URL}?${params}`, {
            signal: controller.signal
        });
        if (resp.status !== 200) {
            throw new Error(`giphy api returned bad status ${resp.status}`);
        }
        const json = await resp.json();
        return json;
    } finally {
        clearTimeout(timeoutId);
    }
}
